import styled from 'styled-components';

import { VerticalHorizontalCenterBlock } from '../../../styled';

export const NotificationLink = styled.a`
  color: ${(props) => props.theme.colors.brand};
  text-decoration: underline;
`;

export const SelectFieldLabel = styled.div`
  margin-right: 4px;
`;

export const BlockWrapper = styled.div`
  margin-bottom: 24px;
`;

export const RestrictAgeAlert = styled.div`
  ${(props) => props.theme.typography.subHeader3};
  margin-bottom: 32px;
`;

export const AgeRestrictLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.brand};
`;

// Fields Preview Frame styles

export const FieldPreviewWrapper = styled.div`
  border-radius: 4px;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const WidgetFrame = styled(VerticalHorizontalCenterBlock)<{ height: number }>`
  border-radius: inherit;
  height: ${(props) => props.height}px;
  background: ${(props) => props.theme.colors.tableCell};
`;
